export default __webpack_public_path__ + "static/layout-do-light-763c63ce7d993e0aa3c6cfe7622b4d7f06cda1551fe115d5a2e1a3ca2f84baca.png";